import React, { useContext } from 'react';
import styled from 'styled-components';
import { bool, func, number, object, string } from 'prop-types';
import { UserContext } from '../auth/hook/userContext';
import { commonRoutes } from '../../routes';
import Box from '../atoms/Box';
import Button from '../atoms/Button';
import Card from '../atoms/Card';
import Text from '../atoms/Text';
import { useTranslate, translateArray } from '../../translate/I18n';
import { useMoney } from '../../hooks/useMoney';
import { SUBSCRIPTIONS } from '../../constants';
import { Link } from '../../utils/router';

const {
  SUBSCRIPTION_FREQUENCE: { MONTHLY }
} = SUBSCRIPTIONS;

const {
  general: { register }
} = commonRoutes;

const StyledList = styled('ul')({
  li: {
    fontWeight: '600',
    listStylePosition: 'outside',
    listStyleType: 'disc'
  }
});

const Plan = ({
  active,
  type,
  price,
  frequence,
  isDisplayed,
  currency,
  onclickPlan,
  selectPlan,
  disabled: cantSelect
}) => {
  const user = useContext(UserContext);
  const { t, i18n } = useTranslate(['common', 'subscription']);
  const money = useMoney();

  return (
    <Card
      p={3}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      border="2px solid"
      overflow="hidden"
      position="relative"
      borderColor={active === type ? 'blue' : 'transparent'}>
      <Box>
        <Text tag="h2" fontSize="22px" mb={2}>
          <Text tag="span" fontWeight="900">
            {t(`subscription:titles:${type}`)}
          </Text>
          <Text tag="span" fontWeight="400" paddingLeft={1}>
            {t(`subscription:icons:${type}`)}
          </Text>
        </Text>

        <Text fontSize="22px" fontWeight="800" mb={3}>
          {money.format(price, currency)}
          <Text tag="span" color="greyDark">
            {frequence === MONTHLY ? t('subscription:perMonth') : t('subscription:perYear')}
          </Text>
        </Text>

        <Box paddingLeft={2}>
          <StyledList>
            {translateArray(t, `subscription:plans.${type}.features`).map((feature, key) => (
              <li key={key}>{feature}</li>
            ))}
          </StyledList>
          {isDisplayed && (
            <Text fontStyle="italic" mb={3} color="greyDark" mt={1}>
              {t(`subscription:plans.${type}.additionalMission`)}
            </Text>
          )}
        </Box>
      </Box>
      <Box>
        {user?.isLoggedIn() ? (
          active === type ? (
            <Box textAlign="center">
              <Button
                data-cy={`btn-subscription-${type}`}
                onClick={() => selectPlan({ type, price })}
                styleType="secondary"
                bg="blue"
                shape="rounded">
                {t('subscription:selectedPlan')}
              </Button>
            </Box>
          ) : (
            <Box textAlign="center">
              <Button
                data-cy={`btn-subscription-${type}`}
                onClick={() => selectPlan({ type, price })}
                styleType="secondary"
                shape="rounded">
                {t('subscription:selectPlan')}
              </Button>
            </Box>
          )
        ) : (
          <Box textAlign="center">
            <Text color="#1b9b76" fontWeight="800" mb={3} cursor="pointer" onClick={onclickPlan}>
              {t('subscription:andMore')}
            </Text>
            <Button
              disabled={cantSelect}
              data-cy={`btn-subscription-${type}`}
              styleType="primary"
              shape="rounded">
              <Link to={register.to}>
                {t('subscription:selectPlan')}
              </Link>
            </Button>
          </Box>
        )}
      </Box>
    </Card>
  );
};

Plan.defaultProps = {
  selectPlan: () => null
};

Plan.propTypes = {
  type: string,
  frequence: string,
  isDisplayed: bool,
  active: string,
  creditsPerYear: number,
  disabled: bool,
  eventType: string,
  title: string,
  price: number,
  currency: string,
  preScreening: number,
  allFrom: string,
  selectPlan: func,
  selectedPlan: object,
  onclickPlan: func
};

export default Plan;
